import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import TranslatesContent from "../../../../DataStore/Languages/translatesContent";

const RegisterButtonResend = ({ reSendOtp }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const verifyRecaptha = async () => {
    if (!executeRecaptcha) {
      return false;
    }

    const token = await executeRecaptcha("yourAction");
    return token;
  };

  const checkRecaptha = (e) => {
    e.preventDefault();
    verifyRecaptha().then((token) => {
      if (token) {
        reSendOtp(e, token);
      } else {
      }
    });
  };

  return (
    <button className="btn cashierButtons" onClick={(e) => checkRecaptha(e)}>
    <TranslatesContent contentKey="resend" />
    </button>
  );
};

export default RegisterButtonResend;
